import {
  Avatar,
  Divider,
  ListItemAvatar,
  ListItemButton,
  ListItemText,
  Box, Typography
} from "@mui/material";

import { useHistory } from "react-router-dom";

import { useUserNotificationContext } from "../../hooks/useUserNotificationContext";
import { useIntl } from "react-intl";


function formatEntitySummary(items, label) {
  if (!items?.length) return null;

  const names = items.slice(0, 3).map((i) => i[`${label}Name`]);
  const remaining = items.length - names.length;

  const prefix = names.join(", ");

  if (remaining > 0) {
    return `${prefix} +${remaining} till`;
  }

  return prefix;
}


function formatNotificationDate(intl, notification) {

  var date = notification.createdAt;

  if (!date) return "";

  const parsedDate = new Date(date);

  const today = new Date();

  const isSameDay =
    parsedDate.getFullYear() === today.getFullYear() &&
    parsedDate.getMonth() === today.getMonth() &&
    parsedDate.getDate() === today.getDate();

  if (isSameDay) {
    return intl.formatTime(parsedDate, {
      hour: "2-digit",
      minute: "2-digit",
    });
  }

  return `${intl.formatDate(parsedDate, {
    dateStyle: "short",
  })} ${intl.formatTime(parsedDate, {
    hour: "2-digit",
    minute: "2-digit",
  })}`;
}

// helpers (dummy for now)
function buildText(notification) {
  const {
    eventChannel,
    folderPayload = [],
    resourcePayload = [],
  } = notification;

  switch (eventChannel) {
    case "FOLDER": {
      const summary = formatEntitySummary(
        folderPayload,
        "folder"
      );

      return {
        id: "notification.folder.updated",
        values: {
          count: folderPayload.length,
          summary,
        },
      };
    }

    case "RESOURCE": {
      const summary = formatEntitySummary(
        resourcePayload,
        "resource"
      );

      return {
        id: "notification.resource.updated",
        values: {
          count: resourcePayload.length,
          summary,
        },
      };
    }

    default:
      return {
        id: "notification.activity",
      };
  }
}

function resolveNotificationRoute(notification) {
  switch (notification.eventChannel) {
    case "FOLDER":
      return `/file-view/${notification.siteId}/${notification.folderPayload[0].folderId}`;

    case "RESOURCE":
      return `/file-view/${notification.siteId}/${notification.resourcePayload[0].folderId}/${notification.resourcePayload[0].resourceId}`;

    case "IMAGE":
      return `/images/${notification.eventId}`;

    default:
      return null;
  }
}

const NotificationItem = ({
  notification,
}) => {
  const history = useHistory();
  const intl = useIntl();

  const {
    markAsRead,
    closePopup,
  } = useUserNotificationContext();

  const message =
    buildText(notification);


  const handleClick = () => {
    markAsRead(
      notification.userNotificationId
    );

    closePopup();

    const route =
      resolveNotificationRoute(notification);

    if (route) {
      history.push(route);
    }
  };


  return (
    <>
      <ListItemButton
        onClick={handleClick}
        sx={{
          alignItems: "flex-start",
          backgroundColor:
            !notification.readAt
              ? "action.hover"
              : "transparent",
          "&:hover": {
            backgroundColor:
              "action.selected",
          },
        }}
      >
        <ListItemAvatar>
          <Avatar
            src={
              notification.actor?.avatarUrl
            }
          />
        </ListItemAvatar>

        <ListItemText
          primary={
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  minWidth: 0,
                }}
              >
                {/* unread dot */}
                {!notification.readAt && (
                  <Box
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: "50%",
                      bgcolor: "primary.main",
                      flexShrink: 0,
                    }}
                  />
                )}

                <Typography
                  variant="body2"
                  noWrap
                >
                  {notification.actor?.name}
                </Typography>
              </Box>

              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ whiteSpace: "nowrap" }}
              >
                {formatNotificationDate(intl, notification)}
              </Typography>
            </Box>
          }
        

secondary={
  <Box>

    {/* flyttad arbetsyta hit */}
    {notification.siteName && (
      <Typography
        variant="caption"
        color="text.secondary"
      >
        {notification.siteName}
      </Typography>
    )}

            <Typography variant="body2" color="text.secondary">
              {intl.formatMessage(
                { id: message.id },
                message.values
              )}
            </Typography>


          </Box>
        }/>
      </ListItemButton>

      <Divider />
    </>
  );
};

export default NotificationItem;